module.exports = __webpack_public_path__ + "static/yaystack_usability_testing_summary_report_compressed-b1e93cda0662e463b018e4888bc88d59.pdf";